import { ChangeDetectionStrategy, Component, Inject, inject, LOCALE_ID } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MAT_DIALOG_DATA, MatDialog, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle } from "@angular/material/dialog";
import { MatFormField, MatFormFieldModule } from "@angular/material/form-field";
import { DateMaskDirective } from "../../Directive/DateMask";
import { MatButton } from "@angular/material/button";
import { AuthService } from "../../../auth/services/auth-service";
import { HomeService } from "../../../components/services/home-service";
import { DatabaseConnection } from "../../services/database-connection";
import { formatDate } from '@angular/common';


@Component({
  selector: 'app-export-modal',
  imports: [
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatDialogTitle,
    MatFormField,
    MatDatepickerModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    DateMaskDirective,
    MatButton
],
  template: `
      <h2 mat-dialog-title class="text-center">Periode d'exportation </h2>
      <mat-dialog-content id="modalDialog" #modalDialog >
          <div class="date-picker-wrapper mt-5">
            <mat-form-field appearance="outline" class="toolbar-date-field w-100">
              <mat-label>Période d'exportation rapport</mat-label>
              <mat-date-range-input [formGroup]="dateForm">
                <input matStartDate appDateMask placeholder="Du" formControlName="date_debut">
                <input matEndDate appDateMask placeholder="Au" formControlName="date_fin">
              </mat-date-range-input>
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-date-range-picker #picker></mat-date-range-picker>
            </mat-form-field>
          </div>
      </mat-dialog-content>
      <mat-dialog-actions align="end">
        <button matButton mat-dialog-close [disabled]="dateForm.invalid" class="bg-mat-green m-3" (click)="downloadRapport()">Exporter</button>
      </mat-dialog-actions>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class ExportComponent {

  readonly dialog = inject(MatDialog);

  readonly url = inject<string>(MAT_DIALOG_DATA);

  dateForm = new FormGroup({
    date_debut : new FormControl(new Date(), [Validators.required]),
    date_fin : new FormControl(new Date(), [Validators.required])
  })

  authService = inject(AuthService)

  constructor(
    private homeService : HomeService,
    private databaseCon : DatabaseConnection,
   @Inject(LOCALE_ID) private locale : string,
  ){}

  downloadRapport(){
    const debut = formatDate(this.dateForm.get('date_debut')?.value!, "yyyy-MM-dd", this.locale)
    const fin = formatDate(this.dateForm.get('date_fin')?.value!, "yyyy-MM-dd", this.locale)
     window.open(this.databaseCon.remoteConnection.value +
     this.url + '?site='+this.authService.getCurrentUser().user?.site?.id+
     '&date_debut='+debut+'&date_fin='+fin+
     '&session_id='+this.authService.getCurrentUser().token.token_id, '_blank')
  }

}